/**
 * Validacion de CUIT/CUIL con algoritmo AFIP (digito verificador mod 11)
 */
export function validateCuit(cuit: string): boolean {
  const clean = cuit.replace(/[^0-9]/g, '');
  if (clean.length !== 11) return false;

  const multipliers = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  let sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(clean[i], 10) * multipliers[i];
  }
  const mod = sum % 11;
  let dv: number;
  if (mod === 0) dv = 0;
  else if (mod === 1) dv = 9;
  else dv = 11 - mod;

  return dv === parseInt(clean[10], 10);
}

/**
 * DNI desde CUIL (posiciones 2-10, 8 digitos)
 */
export function dniFromCuil(cuil: string): string {
  const clean = cuil.replace(/[^0-9]/g, '');
  if (clean.length !== 11) return '';
  return clean.slice(2, 10);
}
